const TOKEN_KEY = 'auth_token';
const ROLE_KEY = 'auth_role';
const EXPIRES_KEY = 'auth_expires_at';
const DISPLAY_NAME_KEY = 'auth_display_name';
const PROFESSIONAL_ID_KEY = 'auth_professional_id';
const HOSPITAL_ID_KEY = 'auth_hospital_id';
const PATIENT_ID_KEY = 'auth_patient_id';
const PATIENT_EMAIL_KEY = 'auth_patient_email';
const PHOTO_BYTES_KEY = 'auth_photo_bytes';
const PHOTO_NAME_KEY = 'auth_photo_name';
const USER_ID_KEY = 'auth_user_id';
const parseExpires = (value) => {
  const parsed = parseInt(value, 10);
  return Number.isFinite(parsed) ? parsed : null;
};

export const setSession = ({ token, role, expiresAt, displayName, professionalId, hospitalId, patientId, patientEmail, photoFileBytes,
  photoFileName, userId,}) => {
  if (token) {
    localStorage.setItem(TOKEN_KEY, token);
  }
  if (role) {
    localStorage.setItem(ROLE_KEY, role);
  }
  if (expiresAt) {
    localStorage.setItem(EXPIRES_KEY, String(expiresAt));
  }
  if (displayName) {
    localStorage.setItem(DISPLAY_NAME_KEY, displayName);
  }
  if (professionalId !== undefined && professionalId !== null) {
    localStorage.setItem(PROFESSIONAL_ID_KEY, String(professionalId));
  }
  if (hospitalId !== undefined && hospitalId !== null) {
    localStorage.setItem(HOSPITAL_ID_KEY, String(hospitalId));
  }
  if (patientId !== undefined && patientId !== null) {
    localStorage.setItem(PATIENT_ID_KEY, String(patientId));
  }
  if (patientEmail) {
    localStorage.setItem(PATIENT_EMAIL_KEY, patientEmail);
  }
  if (photoFileBytes) {
    localStorage.setItem(PHOTO_BYTES_KEY, photoFileBytes);
  }
  if (photoFileName) {
    localStorage.setItem(PHOTO_NAME_KEY, photoFileName);
  }
  if (userId !== undefined && userId !== null) {
    localStorage.setItem(USER_ID_KEY, String(userId));
  }
};

export const clearSession = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(ROLE_KEY);
  localStorage.removeItem(EXPIRES_KEY);
  localStorage.removeItem(DISPLAY_NAME_KEY);
  localStorage.removeItem(PROFESSIONAL_ID_KEY);
  localStorage.removeItem(HOSPITAL_ID_KEY);
  localStorage.removeItem(PATIENT_ID_KEY);
  localStorage.removeItem(PATIENT_EMAIL_KEY);
  localStorage.removeItem(PHOTO_BYTES_KEY);
  localStorage.removeItem(PHOTO_NAME_KEY);
  localStorage.removeItem(USER_ID_KEY);
};

export const getToken = () => localStorage.getItem(TOKEN_KEY);

export const getRole = () => localStorage.getItem(ROLE_KEY);

export const getExpiresAt = () => parseExpires(localStorage.getItem(EXPIRES_KEY));
export const getPhotoFileBytes = () => localStorage.getItem(PHOTO_BYTES_KEY);
export const getPhotoFileName = () => localStorage.getItem(PHOTO_NAME_KEY);
export const getDisplayName = () => localStorage.getItem(DISPLAY_NAME_KEY);
export const getProfessionalId = () => {
  const value = localStorage.getItem(PROFESSIONAL_ID_KEY);
  return value !== null ? Number(value) : null;
};
export const getHospitalId = () => {
  const value = localStorage.getItem(HOSPITAL_ID_KEY);
  return value !== null ? Number(value) : null;
};
export const getPatientId = () => {
  const value = localStorage.getItem(PATIENT_ID_KEY);
  return value !== null ? Number(value) : null;
};
export const getPatientEmail = () => localStorage.getItem(PATIENT_EMAIL_KEY);
export const getUserId = () => {
  const value = localStorage.getItem(USER_ID_KEY);
  return value !== null ? Number(value) : null;
};

export const isExpired = (expiresAt = getExpiresAt()) => {
  if (!expiresAt) return true;
  return Date.now() > expiresAt;
};

export const isAuthenticated = () => {
  const token = getToken();
  if (!token) return false;
  if (isExpired()) {
    clearSession();
    return false;
  }
  return true;
};

export const getUser = () => {
  if (!isAuthenticated()) return null;
  return {
    token: getToken(),
    role: getRole(),
    expiresAt: getExpiresAt(),
    displayName: getDisplayName(),
    professionalId: getProfessionalId(),
    hospitalId: getHospitalId(),
    patientId: getPatientId(),
    patientEmail: getPatientEmail(),
    photoFileBytes: getPhotoFileBytes(),
    photoFileName: getPhotoFileName(),
    userId: getUserId(),
  };
};

export const setAuthSession = ({
  token,
  role,
  expiresInSeconds = 3600,
  expiresAt,
  displayName,
  professionalId,
  hospitalId,
  patientId,
  patientEmail,
  photoFileBytes,
  photoFileName,
  userId,
}) => {
  const targetExpiry = expiresAt || Date.now() + expiresInSeconds * 1000;
  setSession({
    token,
    role,
    expiresAt: targetExpiry,
    displayName,
    professionalId,
    hospitalId,
    patientId,
    patientEmail,
    photoFileBytes,
    photoFileName,
    userId,
  });
  return {
    token,
    role,
    expiresAt: targetExpiry,
    displayName,
    professionalId,
    hospitalId,
    patientId,
    patientEmail,
    photoFileBytes,
    photoFileName,
    userId,
  };
};

